// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2E1Eh","unreadBadge":"styles_unreadBadge__3QZwl","modalContent":"styles_modalContent__15kdY","modal":"styles_modal__2nCiS"};